import React from 'react';
import '../../css/Tilt.scss';
import {Container} from '@material-ui/core';
import StayCurrentLandscapeIcon from '@material-ui/icons/StayCurrentLandscape';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import LanguageSelector from './LanguageSelector';
import { useTranslation } from 'react-i18next';

export default function PleaseTiltDevice({ shouldTilt, shouldUseSafari }) {
	const { t } = useTranslation();
	return <Container>
		<div className='catalog_tilt'>
			{
				shouldTilt && <>
					<span>{t('pleaseTilt')}</span>
					<span><RotateRightIcon fontSize='large' className='tilt-icon' /> <StayCurrentLandscapeIcon fontSize='large' className='tilt-icon' /></span>
				</>
			}
			{
				shouldUseSafari && <>
					<span className='safari'>{t('useSafari')}</span>
				</>
			}
			<LanguageSelector />
		</div>
	</Container>;
}
